/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    Component,
    Input,
} from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import { SchemaService } from 'ajs/modules/core/services/schema-service';
import { BotTypeMatcherConfigItem } from
    'ajs/modules/match/factories/bot-type-matcher.config-item.factory';
import * as l10n from './bot-type-matcher-readonly.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component to show readonly information for bot-type-matcher.
 * @author Akul Aggarwal
 */
@Component({
    selector: 'bot-type-matcher-readonly',
    templateUrl: './bot-type-matcher-readonly.component.html',
})
export class BotTypeMatcherReadonlyComponent {
    @Input()
    public editable: BotTypeMatcherConfigItem;

    public readonly l10nKeys = l10nKeys;

    constructor(
        l10nService: L10nService,
        private readonly schemaService: SchemaService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Convenience method to get text label for selected match criteria.
     */
    public get matchCriteria(): string {
        return this.schemaService.getEnumValueLabel(
            'MatchOperation',
            this.editable.config.op,
        );
    }

    /**
     * Returns text for list of clients, if any, corresponding to criteria.
     */
    public get clientTexts(): string[] {
        return this.editable.config.client_types.map(clientType => {
            return this.schemaService.getEnumValueLabel(
                'BotClientType',
                clientType,
            );
        });
    }

    /**
     * Used in *ngFor.
     */
    public trackByIndex(index: number): number {
        return index;
    }
}
